import type { OnboardingRole } from "../../slices/onboardingSlice";
import { ONBOARDING_STEPS } from "../../slices/onboardingSlice";

import PlanSelectionStep from "./steps/PlanSelectionStep";
import StoreSetupStep from "./steps/StoreSetupStep";
import EmployeesStep from "./steps/EmployeesStep";
import InventoryStep from "./steps/InventoryStep";
import SalesStep from "./steps/SalesStep";
import CustomersStep from "./steps/CustomersStep";

const STEP_COMPONENT_MAP: Record<string, React.FC> = {
  plan_selection: PlanSelectionStep,
  store_setup: StoreSetupStep,
  employees: EmployeesStep,
  inventory: InventoryStep,
  sales: SalesStep,
  customers: CustomersStep,
};

export function getStepComponentsForRole(role: OnboardingRole): React.FC[] {
  return ONBOARDING_STEPS[role].map((step) => STEP_COMPONENT_MAP[step.key]);
}
